// eslint-disable-next-line import/no-default-export
export default [
  { value: 'en', label: 'English' },
  { value: 'es-419', label: 'Español' },
  { value: 'fr', label: 'Français' },
];
